import { Controller } from "@hotwired/stimulus"

// Left slide-over drawer for mobile admin / demo / marketing nav.
// Targets: panel (slides from left), backdrop. Actions: open, close, toggle.
// Closes on Escape, backdrop click, and after Turbo navigation.
export default class extends Controller {
  static targets = ["panel", "backdrop"]

  connect() {
    this.boundEscape = this.onEscape.bind(this)
    this.boundBeforeVisit = this.onTurboNavigate.bind(this)
    document.addEventListener("turbo:before-visit", this.boundBeforeVisit)
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundEscape)
    document.removeEventListener("turbo:before-visit", this.boundBeforeVisit)
    this.unlockScroll()
  }

  open() {
    if (!this.hasPanelTarget) return
    this.panelTarget.classList.remove("-translate-x-full")
    this.panelTarget.classList.add("translate-x-0")
    if (this.hasBackdropTarget) {
      this.backdropTarget.classList.remove("hidden", "opacity-0", "pointer-events-none")
      this.backdropTarget.classList.add("opacity-100")
      this.backdropTarget.setAttribute("aria-hidden", "false")
    }
    document.addEventListener("keydown", this.boundEscape)
    this.lockScroll()
    this.dispatch("opened")
  }

  close() {
    if (!this.hasPanelTarget) return
    this.panelTarget.classList.add("-translate-x-full")
    this.panelTarget.classList.remove("translate-x-0")
    if (this.hasBackdropTarget) {
      this.backdropTarget.classList.remove("opacity-100")
      this.backdropTarget.classList.add("opacity-0", "pointer-events-none")
      this.backdropTarget.setAttribute("aria-hidden", "true")
      setTimeout(() => {
        if (!this.isOpen()) this.backdropTarget.classList.add("hidden")
      }, 200)
    }
    document.removeEventListener("keydown", this.boundEscape)
    this.unlockScroll()
    this.dispatch("closed")
  }

  toggle() {
    if (this.isOpen()) this.close()
    else this.open()
  }

  isOpen() {
    return this.hasPanelTarget && this.panelTarget.classList.contains("translate-x-0")
  }

  onEscape(e) {
    if (e.key === "Escape") this.close()
  }

  onTurboNavigate() {
    if (this.isOpen()) this.close()
  }

  backdropClose() {
    this.close()
  }

  lockScroll() {
    this._scrollY = window.scrollY ?? window.pageYOffset
    document.body.style.overflow = "hidden"
    document.body.style.position = "fixed"
    document.body.style.top = `-${this._scrollY}px`
    document.body.style.left = "0"
    document.body.style.right = "0"
    document.body.style.width = "100%"
  }

  unlockScroll() {
    document.body.style.overflow = ""
    document.body.style.position = ""
    document.body.style.top = ""
    document.body.style.left = ""
    document.body.style.right = ""
    document.body.style.width = ""
    if (typeof this._scrollY === "number") {
      window.scrollTo(0, this._scrollY)
    }
  }
}
